setInterval(()=>{
  changeText();
},5000);

function changeText() {
  document.querySelectorAll('.axt-floting-text-main').forEach((ele)=>{
    ele.classList.toggle('text-change');
  })
}

$('span.axt-pop-cls').click(function(){
  $('.axt-popups-wrapper').hide();
})

function removeAllItems() {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function(data) {
        return true;
      }
    });
}

async function checkAxt(axtCheck) {
  let cartData = await getCart();
  let cartItems = cartData.items;
  if(cartItems.length > 0){
    let inAxt = false;
    for (let i = 0; i < cartItems.length; i++) {
      if(cartItems[i].handle == 'purchase-the-limited-edition-box'){
        inAxt = true;
      }
    }
    if(axtCheck==true){
        $('.axt-popups-wrapper').show();
        $('.taimi-pro-text').hide();
        $('.aug-pro-text').show();
        // removeAllItems();
    }else{
      if(inAxt){
        $('.axt-popups-wrapper').show();
        $('.taimi-pro-text').show();
        $('.aug-pro-text').hide();
        // removeAllItems();
      }
    }
  }else{
    return true;
  }
}